import { jsx as _jsx } from "react/jsx-runtime";
import { useManageState } from '@kubit/web-ui-components/hooks/useManageState';
import { useStylesV2 } from '@kubit/web-ui-components/hooks/useStyles';
import * as React from 'react';
import { STYLES_NAME } from '../../constants/stylesName/stylesName';
import { IconButtonStandAlone } from './iconButtonStandAlone';
import { IconButtonStateType } from './types/state';
export const IconButton = React.forwardRef(function IconButton({ variant, size, disabled = false, ctv, ...props }, ref) {
    const sizeStyles = useStylesV2({
        styleName: STYLES_NAME.ICON_BUTTON,
        variantName: variant,
        customTokens: ctv,
    })?.[size];
    const { state, setRef } = useManageState({
        states: Object.values(IconButtonStateType),
        ref: ref,
        disabled,
        loading: false,
    });
    const [twisted, setTwisted] = React.useState(false);
    const styles = sizeStyles?.[state];
    const handleClick = event => {
        if (props.twistedIcon) {
            setTwisted(!twisted);
            if (!twisted) {
                props.icon.onClick?.(event);
            }
            else {
                props.twistedIcon.onClick?.(event);
            }
        }
        else {
            props.icon.onClick?.(event);
        }
    };
    return (_jsx(IconButtonStandAlone, { ...props, ref: setRef, disabled: disabled, styles: styles, twisted: twisted, onClick: !props.icon.onClick ? undefined : handleClick }));
});
//# sourceMappingURL=iconButton.js.map